/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React, { styled, useFlux } from 'fierry/react.old';

import BorderCenter from 'galax/react/map/hex/border.center';

import random from 'fierry/util/random';


const getUnderlineWidth = ({ geometry }) =>
{
  return geometry.getHex().getExternalWidth(0.5);
}


const getUnderlineHeight = ({ geometry }) =>
{
  return geometry.getHex().getExternalHeight(0.25);
}


const getUnderlineStrokeWidth = ({ geometry }) =>
{
  return geometry.getHex().getExternalSize(0.05);
}


const Underline = styled.line`
  stroke: var(--svg-always-other);
  stroke-width: ${props => getUnderlineStrokeWidth(props)};
  stroke-linecap: clip;
`;


const getUnderlineProps = (props) =>
{
  const width = getUnderlineWidth(props);
  const height = getUnderlineHeight(props);

  const x1 = -1/2 * width;
  const x2 = 1/2 * width;

  const y1 = height;
  const y2 = height;

  return { x1, y1, x2, y2 };
}


const Circle = styled.circle`
  fill: var(--svg-always-other);
  stroke: none;
`;


const FromCenterLine = (props) =>
{
  const { borderGeometry } = props;

  return <Underline {...props} x1 = {0} x2 = {borderGeometry.getCenterToPartitionDistance()} y1 = {0} y2 = {0} />;
}


const Triangle = (props) =>
{
  const points = props.borderGeometry.getRotatedPoints();

  return (
    <>
      <Underline {...props} x1 = {points[0].x} y1 = {points[0].y} x2 = {points[1].x} y2 = {points[1].y} />
      <Underline {...props} x1 = {points[1].x} y1 = {points[1].y} x2 = {points[2].x} y2 = {points[2].y} />
      <Underline {...props} x1 = {points[2].x} y1 = {points[2].y} x2 = {points[0].x} y2 = {points[0].y} />
    </>)

  return null;
}


const ComponentTriangle = (props) =>
(
    <BorderCenter {...props} index = {4} Component = {Triangle} />
)


const Component = (props) =>
(
  <Underline {...props} {...getUnderlineProps(props)} />
);


export default ({ currentLocation, ...props }) =>
{
  const value = random(6);

  return <Component {...props} value = {value} location = {currentLocation} />;
};
